// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/BloqueiosAgenda_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /bloqueios_agenda/save
 *
 * Validates schedule blocking creation/update requests. Used by save(),
 * create(), and update() methods. Datetime fields must be in ISO 8601 UTC format.
 */
import { registerContract } from './validate'

export interface BloqueiosAgenda_SaveInput {
bloqueio_agenda_titulo: string
bloqueio_agenda_operador_user_id: string
bloqueio_agenda_data_hora_inicio: string
bloqueio_agenda_data_hora_fim: string
bloqueio_agenda_id?: number
}

registerContract('BloqueiosAgenda_SaveInput', {
  bloqueio_agenda_titulo:           { type: 'string',  required: true },
  bloqueio_agenda_operador_user_id: { type: 'string',  required: true },
  bloqueio_agenda_data_hora_inicio: { type: 'string',  required: true },
  bloqueio_agenda_data_hora_fim:    { type: 'string',  required: true },
  bloqueio_agenda_id:               { type: 'number',  required: false },
})
